/** @jsxImportSource @emotion/react */

import type { ChangeEventHandler } from "react";
import type { RadioProps } from "..";
import { Flex } from "..";
import { radioIconCSS } from "./Radio.css";
import {
  useRadioGroupAction,
  useRadioGroupName,
  useRadioGroupValue,
} from "./RadioGroup/RadioGroup.provider";

const RadioIcon = () => {
  return (
    <Flex
      display="inline-flex"
      className="clay-radio-icon"
      shape="circle"
      size="16px"
      css={radioIconCSS}
    />
  );
};

export const Radio = ({ onChange, onChangeValue, checked, name, ...restProps }: RadioProps) => {
  const contextName = useRadioGroupName();
  const contextValue = useRadioGroupValue();
  const contextAction = useRadioGroupAction();
  const contextIsChecked = contextValue ? contextValue === restProps.value : checked;

  const _onChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const newValue = e.target.value;

    onChange?.(e);
    contextAction?.(newValue);
    onChangeValue?.(newValue);
  };

  return (
    <Flex display="inline-flex" as="label" native={{ htmlFor: restProps.id }}>
      <input
        data-clay-blind
        onChange={_onChange}
        type="radio"
        name={contextName || name}
        checked={contextIsChecked}
        {...restProps}
      />
      <RadioIcon />
    </Flex>
  );
};
